const TCIntl = require('./src/TCIntl');
const {
	LANGUAGE_ALIASES,
	LANGUAGE_FALLBACK,
	LANGUAGE_UNDETERMINED,
	TRANSLATION_PROVIDERS
} = require('./src/constants');
const { DEEPL_TARGET_LANGUAGES, DEEPL_SOURCE_LANGUAGES } = require('./src/deepLLanguages');
const { GOOGLE_LANGUAGES } = require('./src/googleLanguages');
const LANGUAGE_CODES = require('./src/languageCodes');
const { languageEquals } = require('./src/utils');

module.exports = {
	TCIntl,
	DEEPL_SOURCE_LANGUAGES,
	DEEPL_TARGET_LANGUAGES,
	GOOGLE_LANGUAGES,
	LANGUAGE_ALIASES,
	LANGUAGE_CODES,
	LANGUAGE_FALLBACK,
	LANGUAGE_UNDETERMINED,
	TRANSLATION_PROVIDERS,
	languageEquals,
};
